import React from 'react';

const CalendarIcon = ({ size = 33, ...props }) => (
  <svg
    width={Math.round((size * 24) / 20)}
    height={size}
    viewBox='0 0 24 20'
    fill='currentColor'
    {...props}>
    <path d='M23.8703 2.38035L20.9975 16.654H18.7166L20.1538 9.51802H4.19504L2.75785 16.654H18.7166L18.238 19.0344H-2.37683e-05L2.87272 4.75901H5.15208L4.67355 7.13768H20.6339L21.1124 4.75901H5.15369L5.63221 2.38035H7.91157L8.39008 0H10.6694L10.1909 2.38035H17.0306L17.5091 0H19.7901L19.31 2.38035H23.8703Z' />
  </svg>
);

export default CalendarIcon;
